import React, { useContext, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';

const DeletePopinModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const popin = modalDetails?.popin;
  const hasCoupon = !!popin?.hasCoupon || !!popin?.couponId;
  const hasLiveContent = !!popin?.liveCouponId || popin?.status !== 'draft';

  const closeHandle = () => modalCtx.closeModal();

  const handleDelete = async () => {
    if (!popin?.id) return;
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/popin/${popin.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authCtx.token
        }
      });
      const data = await response.json();
      if (data.status === 'success') {
        modalCtx.closeModal();
        modalCtx.setPageUpdate({ page: 'Popins', popinId: popin.id });
      }
    } catch (error) {
      console.error('Error deleting pop-in:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-devotional-container" style={{ width: '500px' }}>
      <div className="devotional-header">
        <h1>Delete Pop-in</h1>
        <CloseRounded className="close" onClick={closeHandle} />
      </div>
      <div className="body-container create-container">
        <p>Are you sure you want to permanently delete this pop-in?</p>
        <p style={{ fontSize: '12px', color: '#555', marginTop: '.25rem' }}>
          {hasCoupon
            ? 'This will permanently delete the pop-in, its locations, linked draft coupon, and hard-delete the live company, coupons, and related company or coupon records.'
            : hasLiveContent
              ? 'This will permanently delete the pop-in, its locations, and hard-delete the live company and its locations.'
              : 'This action will permanently delete the pop-in and its locations.'}
        </p>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={loading}>Cancel</Button>
        <Button onClick={handleDelete} disabled={loading}>
          {loading ? <CircularProgress size={16} style={{ color: '#fff' }} /> : 'Delete'}
        </Button>
      </div>
    </div>
  );
};

export default DeletePopinModal;
